import { Component } from '@angular/core';
import { CommonModule } from '@angular/common'; // ← pour *ngIf, etc.
import { FormsModule } from '@angular/forms'; // ← pour [(ngModel)]

type ContactForm = {
  name: string;
  email: string;
  company: string;
  how: string;
  subject: string;
  message: string;
};

@Component({
  selector: 'app-contact',
  standalone: true, // ← composant standalone
  imports: [CommonModule, FormsModule], // ← directives disponibles dans le template
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css'],
})
export class ContactComponent {
  form: ContactForm = {
    name: '',
    email: '',
    company: '',
    how: '',
    subject: '',
    message: '',
  };

  loading = false;
  successMessage = '';
  errorMessage = '';
  readonly maxLen = 3000;

  get charCount(): number {
    return this.form.message?.length || 0;
  }

  // URL de la Cloud Function
  private readonly endpoint = 'https://us-central1-qaryos.cloudfunctions.net/sendContactMail';

  async onSubmit(event: Event) {
    event.preventDefault();
    this.successMessage = '';
    this.errorMessage = '';

    if (
      !this.form.name ||
      !this.form.email ||
      !this.form.company ||
      !this.form.subject ||
      !this.form.message
    ) {
      this.errorMessage = 'Merci de remplir tous les champs obligatoires.';
      return;
    }

    this.loading = true;
    try {
      const payload = {
        name: this.form.name.trim(),
        company: this.form.company.trim(),
        email: this.form.email.trim(),
        offre: this.form.subject.trim(),
        message: (this.form.how ? `Origine: ${this.form.how}\n\n` : '') + (this.form.message || ''),
      };

      const resp = await fetch(this.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!resp.ok) {
        let details = '';
        try {
          const data = await resp.json();
          details = data?.details || JSON.stringify(data);
        } catch {
          details = await resp.text();
        }
        throw new Error(`HTTP ${resp.status} ${details}`);
      }

      this.successMessage = 'Votre message a bien été envoyé. Merci !';
      this.form = { name: '', email: '', company: '', how: '', subject: '', message: '' };
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err: any) {
      console.error('Erreur envoi contact:', err);
      this.errorMessage = 'Envoi impossible pour le moment. Réessayez dans 1 minute.';
    } finally {
      this.loading = false;
    }
  }
}
